
import { Link } from "react-router-dom";
import { ImCheckmark } from "react-icons/im";
import { colors } from "../../config/colors";

const MaterialCard = ({ material, icon, tooltipId }) => {
  return (
    <Link
      to={`${material.activityid}`}
      className="cursor-pointer"
    >
      <div
        className="bg-bar_score relative hover:scale-110 duration-200 p-1 rounded"
        data-for={tooltipId}
        data-tip={String(material.activityid)}
      >
        {material.completed && (
          <div
            className="absolute opacity-60 content-end"
            style={{ bottom: 0, right: 0 }}
          >
            <ImCheckmark
              size={20}
              color={colors.bar_empty_light}
            />
          </div>
        )}

        {icon && <div>{icon}</div>}
      </div>
    </Link>
  );
};

export default MaterialCard;
